/* tslint:disable */
/* eslint-disable */
/**
 * Torrents Stream Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
    ProviderCategoryModelSubcategories,
    ProviderCategoryModelSubcategoriesFromJSON,
    ProviderCategoryModelSubcategoriesFromJSONTyped,
    ProviderCategoryModelSubcategoriesToJSON,
} from './'

/**
 *
 * @export
 * @interface ProviderTorrentModel
 */
export interface ProviderTorrentModel {
    /**
     *
     * @type {string}
     * @memberof ProviderTorrentModel
     */
    id: string
    /**
     *
     * @type {string}
     * @memberof ProviderTorrentModel
     */
    name: string
    /**
     *
     * @type {string}
     * @memberof ProviderTorrentModel
     */
    magnet?: string
    /**
     *
     * @type {number}
     * @memberof ProviderTorrentModel
     */
    seeds: number
    /**
     *
     * @type {number}
     * @memberof ProviderTorrentModel
     */
    downloads?: number
    /**
     *
     * @type {number}
     * @memberof ProviderTorrentModel
     */
    peers: number
    /**
     *
     * @type {number}
     * @memberof ProviderTorrentModel
     */
    comments?: number
    /**
     *
     * @type {string}
     * @memberof ProviderTorrentModel
     */
    size: string
    /**
     *
     * @type {number}
     * @memberof ProviderTorrentModel
     */
    time?: number
    /**
     *
     * @type {string}
     * @memberof ProviderTorrentModel
     */
    link?: string
    /**
     *
     * @type {boolean}
     * @memberof ProviderTorrentModel
     */
    isVip?: boolean
    /**
     *
     * @type {string}
     * @memberof ProviderTorrentModel
     */
    imdb?: string
    /**
     *
     * @type {number}
     * @memberof ProviderTorrentModel
     */
    numFiles?: number
    /**
     *
     * @type {string}
     * @memberof ProviderTorrentModel
     */
    provider: string
    /**
     *
     * @type {ProviderCategoryModelSubcategories}
     * @memberof ProviderTorrentModel
     */
    category?: ProviderCategoryModelSubcategories
}

export function ProviderTorrentModelFromJSON(json: any): ProviderTorrentModel {
    return ProviderTorrentModelFromJSONTyped(json, false)
}

export function ProviderTorrentModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): ProviderTorrentModel {
    if (json === undefined || json === null) {
        return json
    }
    return {
        id: json['id'],
        name: json['name'],
        magnet: !exists(json, 'magnet') ? undefined : json['magnet'],
        seeds: json['seeds'],
        downloads: !exists(json, 'downloads') ? undefined : json['downloads'],
        peers: json['peers'],
        comments: !exists(json, 'comments') ? undefined : json['comments'],
        size: json['size'],
        time: !exists(json, 'time') ? undefined : json['time'],
        link: !exists(json, 'link') ? undefined : json['link'],
        isVip: !exists(json, 'isVip') ? undefined : json['isVip'],
        imdb: !exists(json, 'imdb') ? undefined : json['imdb'],
        numFiles: !exists(json, 'numFiles') ? undefined : json['numFiles'],
        provider: json['provider'],
        category: !exists(json, 'category')
            ? undefined
            : ProviderCategoryModelSubcategoriesFromJSON(json['category']),
    }
}

export function ProviderTorrentModelToJSON(
    value?: ProviderTorrentModel | null
): any {
    if (value === undefined) {
        return undefined
    }
    if (value === null) {
        return null
    }
    return {
        id: value.id,
        name: value.name,
        magnet: value.magnet,
        seeds: value.seeds,
        downloads: value.downloads,
        peers: value.peers,
        comments: value.comments,
        size: value.size,
        time: value.time,
        link: value.link,
        isVip: value.isVip,
        imdb: value.imdb,
        numFiles: value.numFiles,
        provider: value.provider,
        category: ProviderCategoryModelSubcategoriesToJSON(value.category),
    }
}
